import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	isLoginModalOpen: false,
};

const uiSlice = createSlice({
	name: 'ui',
	initialState,
	reducers: {
		showLoginModal: (state) => {
			state.isLoginModalOpen = true;
		},
		hideLoginModal: (state) => {
			state.isLoginModalOpen = false;
		},
	},
});

export const { showLoginModal, hideLoginModal } = uiSlice.actions;
export const selectUiState = (state) => state.ui;
export default uiSlice.reducer;
